// extracted by mini-css-extract-plugin
export var quillEditor = "_ou-1";
export var variable = "_ou-0";